<oaj-dashboard-autoridades
    [attr.api-url]="apiUrl"
    selection-mode="single"
    consulta="true">
</oaj-dashboard-autoridades>